import { z } from 'zod';

/**
 * A subdivision of a parcel. `ucf` is the full designation (`1A1` =
 * parcel `1A`, subpolygon `1`); `number` is the trailing part alone.
 */
export const SubParcelSchema = z.object({
  id: z.string().uuid(),
  /** Null while the subpolygon lies in no known polygon (for review). */
  parcelId: z.string().uuid().nullable(),
  ucf: z.string(),
  /** Trailing number; empty while unattached. */
  number: z.string(),
  /** 'shapefile' or 'receptie' (a reception archive). */
  source: z.string(),
  /** Hectares as declared on import, else computed from the outline. */
  suprafata: z.number(),
  suprafataCalculata: z.number().nullable(),
  /** Reception metadata; null for shapefile rows. */
  anul: z.number().int().nullable(),
  sezon: z.enum(['PRIMAVARA', 'TOAMNA']).nullable(),
  parcele: z.string().nullable(),
  sourceFile: z.string().nullable(),
  primarie: z.string().nullable(),
  raion: z.string().nullable(),
  entitateSilvica: z.string().nullable(),
  geometryType: z.string(),
  geometry: z.unknown(),
  userId: z.string().uuid(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type SubParcelDto = z.infer<typeof SubParcelSchema>;

/** The subpolygon a photo falls in, attached to photo reads. */
export const SubParcelBriefSchema = z.object({
  id: z.string().uuid(),
  ucf: z.string(),
  number: z.string(),
  suprafata: z.number(),
});
export type SubParcelBrief = z.infer<typeof SubParcelBriefSchema>;
